import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import 'rxjs/add/operator/map'

@Injectable()
export class MapaService {
  Url = "./assets/json/estado.json"

  constructor(private _http:HttpClient) {

   }

   getmunicipios(){
     return this._http.get(this.Url)
   }
}



// WEBPACK FOOTER //
// ./src/app/services/mapa.service.ts